import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { oppLocalStorage, TStorageNames } from 'helpers/storage';

const AccessLeasePacket = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const leasePacketCode = searchParams.get('leasePacketCode');

  useEffect(() => {
    if (leasePacketCode) {
      oppLocalStorage.setItem(TStorageNames.leasePacketCode, leasePacketCode);
    }
    if (params.leasePacketCode) {
      oppLocalStorage.setItem(TStorageNames.leasePacketCode, params.leasePacketCode);
    }
    navigate(`/signup`, { replace: true });
  }, []);
  return null;
};

export default AccessLeasePacket;
